<template>
  <div class="view_stamp">
    <!-- <div>
      서울둘레길 QR 인증
      <div v-if="latitude && longitude">
        {{`좌표: ${latitude}, ${longitude}`}}
      </div>
      <div v-else>
        좌표 정보 불러오는중...
      </div>
    </div> -->
    <!-- 휴대전화입력 팝업 -->
    <div v-if="typePopup1" class="pop_overay">
      <div class="pop_cont">
        <div class="text_box">
            <p>서울둘레길 방문 인증을 위하여 본인의 휴대폰 번호를 입력 후 ‘전송'버튼을 누르세요.</p>
            <div class="phone">
              <span>휴대폰번호 입력</span>
              <input
                type="text"
                v-model="phone"
                inputmode="numeric"
                maxlength="13"
                placeholder="휴대폰번호를 입력해주세요."
                @keydown="phoneAutoDash($event, phone, 't1')"
                />
              <span>휴대폰번호 확인</span>
              <input
                type="text"
                v-model="phoneCheck"
                inputmode="numeric"
                maxlength="13"
                placeholder="휴대폰번호를 다시 한번 입력해주세요."
                @keydown="phoneAutoDash($event, phoneCheck, 't2')"
                />
            </div>
        </div>
        <button class="type1" @click="closeWindow">닫기</button>
        <!-- <button class="type2" :disabled="phoneSameCheck()" @click="submitPhone" >전송</button> -->
        <button class="type2" :class="{disabled: phoneSameCheck()}" @click="submitPhone" >전송</button>
      </div>
    </div>
    <!-- 전화번호 틀림 팝업 -->
    <div v-if="typePopup2" class="pop_overay">
      <div class="pop_cont">
        <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
        <div class="text_2">
          휴대폰 번호를 올바르게 입력해 주세요.
        </div>
        <button @click="typePopup2 = false">다시하기</button>
      </div>
    </div>
    <!-- 전화번호 서로 다름 팝업 -->
    <div v-if="typePopup7" class="pop_overay">
      <div class="pop_cont">
        <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
        <div class="text_2">
          휴대폰 번호가 일치하지 않습니다. 다시 입력해 주세요.
        </div>
        <button @click="typePopup7 = false">다시하기</button>
      </div>
    </div>
    <!-- 위치다름 팝업 -->
    <div v-if="typePopup3" class="pop_overay">
      <div class="pop_cont">
        <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
        <div class="text_2">
          스탬프가 있는 위치에서 <b>{{ getDis }}</b> 떨어져 있습니다. 스탬프가 있는 곳으로 가까이 이동 후 다시 스캔을 해 주세요.
        </div>
        <button @click="closeWindow">닫기</button>
      </div>
    </div>
    <!-- 인증요청 팝업 -->
    <div v-if="typePopup4" class="pop_overay">
      <div class="pop_cont">
        <div class="stamp_box">
          <div class="title">인증을 축하합니다.<br /><span>“{{ dulleRegistInfo.mingle_stamp_name }}”</span></div>
          <img class="stamp_img" :src="dulleRegistInfo.mingle_stamp_image" />
          <ul>
            <li><span>휴대폰번호</span>{{ dulleRegistInfo.phone }}</li>
            <li><span>스탬프명</span>{{ dulleRegistInfo.mingle_stamp_name }}</li>
            <li><span>발급일시</span>{{ dulleRegistInfo.date }}</li>
          </ul>
          <img class="seoul_logo" src="@/assets/images/seoul_logo.png" alt="seoul_logo">
        </div>
        <div class="thema_noti">
          <div class="notice">Notice</div>
          <div class="txt">화면을 캡쳐해서 서울둘레길 안내센터에<br />제출하세요.</div>
        </div>
        <button @click="goAllThat">인증 이력 보관하기</button>
      </div>
    </div>
    <!-- 위치다름 팝업 -->
    <div v-if="typePopup5" class="pop_overay">
      <div class="pop_cont">
        <img class="icon_img" src="@/assets/images/popup_icon_stamp.png" alt="icon">
        <div class="text_2 t1">
          <div class="stamp mb"><b>{{ lastTime }} 전</b>에 동일 스탬프가 발급되었습니다.</div>
          <b>{{ remainTime }}</b> 경과 후 다시 받으실 수 있습니다.
        </div>
        <div class="thema_noti">
          <div class="notice">Notice</div>
          <div class="txt">동일 스탬프는 12시간 경과해야 발급됩니다.</div>
        </div>
        <button @click="closeWindow">닫기</button>
      </div>
    </div>
    <!-- qr반영 팝업 -->
    <div v-if="typePopup6" class="pop_overay">
      <div class="pop_cont">
        <img class="icon_img" src="@/assets/images/popup_icon_stamp.png" alt="icon">
        <div class="text_2 t1">
          <div class="stamp">QR코드 스캔을 인증한 스탬프를<br />반영합니다.</div>
        </div>
        <div class="thema_noti">
          <div class="txt"><b>5초</b> 후 자동 닫힘</div>
        </div>
        <button>닫기</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SeoulDulegil',
  components: {
  },
  data () {
    return {
      typePopup1: false,
      typePopup2: false,
      typePopup3: false,
      typePopup4: false,
      typePopup5: false,
      typePopup6: false,
      typePopup7: false,
      latitude: 0,
      longitude: 0,
      phone: '',
      phoneCheck: '',
      stampImg: '',
      getStamp: '',
      getDis: '',
      regdate: '2022-10-19 13:00:00',
      lastTime: '',
      remainTime: ''
    }
  },
  computed: {
    ...mapState(['stampDistanceInfo', 'dulleRegistInfo'])
  },
  watch: {
    stampDistanceInfo () {
      if (this.stampDistanceInfo.get_stamp === 'true') {
        // 50m 안으로 들어옴
        this.typePopup1 = true
      } else {
        const dis = parseInt(this.stampDistanceInfo.dist)
        this.getDis = dis > 1000 ? `${parseInt(dis / 1000)}km` : `${parseInt(dis)}m`
        this.typePopup3 = true
      }
    },
    dulleRegistInfo () {
      this.typePopup1 = false
      if (!this.dulleRegistInfo.mingle_stamp_name) {
        this.lastTime = this.getLastTime(this.dulleRegistInfo.date)
        this.remainTime = this.getRemainTime(this.dulleRegistInfo.date)
        this.typePopup5 = true
      } else {
        this.typePopup4 = true
      }
    }
  },
  methods: {
    getGeoLocation () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude // 37.58795216
        this.longitude = position.coords.longitude // 127.1069032
        // 테스트용 임시
        // this.latitude = 37.58795216
        // this.longitude = 127.1069032
        this.$store.dispatch('loadStampDistance', {
          lat: this.latitude,
          lon: this.longitude,
          stamp: this.$route.query.stamp_id || ''
        })
      }, (error) => {
        console.log(error)
        alert('GPS정보를 가져올 수 없습니다. 내 위치 확인을 허용해주세요.\n 안드로이드: 설정 > 위치 > 앱 권한 > 삼성 인터넷 또는 Chrome > 허용 클릭 \n 아이폰: 설정 > Safari > 위치 >  허용 클릭')
      })
    },
    phoneAutoDash ($event, str, type) {
      if ($event.keyCode !== 8 && (str.length === 3 || str.length === 8)) {
        if (type === 't1') {
          this.phone = `${this.phone}-`
        } else {
          this.phoneCheck = `${this.phoneCheck}-`
        }
      }
    },
    phoneSameCheck () {
      return (!this.phone && !this.phoneCheck) || this.phone !== this.phoneCheck
    },
    submitPhone () {
      if (this.phone !== this.phoneCheck) {
        this.typePopup7 = true
      } else {
        const reg = /^01([0|1|6|7|8|9])-([0-9]{3,4})-([0-9]{4})$/gi
        if (!reg.test(this.phone)) {
          this.typePopup2 = true
          return false
        }
        this.$store.dispatch('loadDulleRegist', {
          phone: this.phone,
          stamp: this.$route.query.stamp_id || ''
        })
      }
    },
    // 거리 측정
    getDistanceFromLatLonInKm (lat1, lng1, lat2, lng2) {
      const R = 6371
      const dLat = this.deg2rad(lat2 - lat1)
      const dLon = this.deg2rad(lng2 - lng1)
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      const d = R * c
      return d
    },
    deg2rad (deg) {
      return deg * (Math.PI / 180)
    },
    goAllThat () {
      location.href = 'https://allthatstamp.page.link/mVFa'
    },
    getLastTime (regTime) {
      const date = new Date()
      const diff = (date.getTime() - new Date(regTime.replace(/-/g, '/')).getTime()) / 1000
      const hour = parseInt(diff / 60 / 60)
      const minute = parseInt(diff / 60 % 60) + 1
      return hour ? `${hour}시간 ${minute}분` : `${minute}분`
    },
    getRemainTime (regTime) {
      const date = new Date()
      let diff = (date.getTime() - new Date(regTime.replace(/-/g, '/')).getTime()) / 1000
      const time = 43200 // 12시간
      diff = time - diff
      const hour = parseInt(diff / 60 / 60)
      const minute = parseInt(diff / 60 % 60)
      return hour ? `${hour}시간 ${minute}분` : `${minute}분`
    },
    closeWindow () {
      window.close()
    }
  },
  mounted () {
    if (!this.$route.query.stamp_id) {
      alert('스탬프id 정보가 없습니다.')
      return false
    }
    // 위치 확인
    this.getGeoLocation()
  }
}
</script>
<style>
  .pop_overay .pop_cont .text_box {
    font-size: 14px;
    color:#010101;
    background:#fff;
    padding:35px 20px 14px;
    font-family:inaviL;
  }
  .pop_overay .pop_cont .text_box p {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin: 0 13px;
    word-break: keep-all;
  }
  .pop_overay .pop_cont .text_box .phone {
    margin-top: 18px;
  }
  .pop_overay .pop_cont .text_box .phone span {
    font-family:inaviM;
    display: block;
    font-size: 12px;
    text-align: left;
    margin-bottom: 5px;
  }
  .pop_overay .pop_cont .text_box .phone input {
    width: 100%;
    padding: 5px 0;
    font-size: 12px;
    color: #000000;
    font-family:inaviL;
    border: 0;
    border-bottom: 1px solid #000;
    margin-bottom: 18px;
  }
  .pop_overay .pop_cont button:disabled {
    user-select: none;
    background-color: #EDEEEF;
    color: #B5B5B5;
  }
  .pop_overay .pop_cont button.disabled {
    user-select: none;
    background-color: #EDEEEF;
    color: #B5B5B5;
  }
  .pop_overay .pop_cont .text_2 {
    padding: 60px 20px 20px;
  }
  .pop_overay .pop_cont .text_2.t1 {
    padding: 60px 10px 27px;
  }
  .pop_overay .pop_cont b {
    font-weight: normal;
    color: #C86550;
  }
  .pop_overay .pop_cont .text_2 .stamp {
    font-size: 17px;
    line-height: 25px;
  }
  .pop_overay .pop_cont .text_2 .stamp.mb {
    margin-bottom: 23px;
  }
  .pop_overay .pop_cont .stamp_box {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color:#010101;
    background:#fff;
    padding:35px 20px 27px;
    font-family:inaviL;
    align-items: center;
  }
  .pop_overay .pop_cont .stamp_box .title {
    line-height: 25px;
  }
  .pop_overay .pop_cont .stamp_box .title span {
    color: #3BB9FA;
    font-weight: normal;
    font-size: 17px;
  }
  .pop_overay .pop_cont .stamp_box ul {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 18px 0;
  }
  .pop_overay .pop_cont .stamp_box ul li {
    text-align: left;
    line-height: 21px;
  }
  .pop_overay .pop_cont .stamp_box ul li span {
    color: #3BB9FA;
    display: inline-block;
    width: 65px;
    margin-right: 10px;
  }
  .pop_overay .pop_cont .stamp_box .stamp_img {
    width: 150px;
  }
  .pop_overay .pop_cont .stamp_box .seoul_logo {
    width: 90px;
  }
</style>
